// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.op-skeleton-checkbox{display:flex;gap:0.5714285714rem}`, "",{"version":3,"sources":["webpack://./app/new-components/DLS/OpSkeleton/OpSkeleton.scss"],"names":[],"mappings":"AAEA,sBACE,YAAA,CACA,mBAAA","sourcesContent":["@use 'assets/scss/common';\n\n.op-skeleton-checkbox {\n  display: flex;\n  gap: common.toRem(8);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
